import { Component, OnInit, inject } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { MainLayout } from '../../layouts/main-layout';

@Component({
  selector: 'allas-bolsa-empleo',
  imports: [MainLayout],
  template: `
    <allas-main-layout [showPopularSections]="true" [showNewsletter]="true">
      <div class="container mx-auto px-4 py-8">
        <div class="mb-6 fs-condensed">
          <h1 class="text-3xl font-bold text-gray-900 mb-2">Bolsa de Empleo</h1>
          <p class="text-gray-600">
            Explora las oportunidades laborales disponibles en ALLAS Repuestos
          </p>
        </div>

        <div
          class="w-full h-screen border border-gray-200 rounded-lg overflow-hidden shadow-lg"
        >
          <iframe
            src="https://allasenlinea.com/portal-vacantes/#/bolsa-empleo"
            class="w-full h-full"
            frameborder="0"
            allowfullscreen
            title="Portal de Vacantes ALLAS Repuestos"
          >
          </iframe>
        </div>
      </div>
    </allas-main-layout>
  `,
})
export class BolsaEmpleo implements OnInit {
  private title = inject(Title);
  private meta = inject(Meta);

  ngOnInit() {
    this.setMetaTags();
  }

  private setMetaTags() {
    const pageTitle = 'Bolsa de Empleo | Allas Repuestos';
    const description =
      'Oportunidades laborales en Allas Repuestos: asesor de ventas, gerente de ventas, asistente de bodega, desarrollador web, cajero. Trabajos en Tegucigalpa, San Pedro Sula, La Ceiba, Choloma, Villanueva.';
    const keywords =
      'bolsa empleo, trabajo Honduras, asesor de ventas, gerente de ventas, asistente de bodega, desarrollador web, cajero cajera, vacantes Tegucigalpa, empleo San Pedro Sula, trabajo La Ceiba, empleos Choloma, trabajo Villanueva, Allas Repuestos, oportunidades laborales';
    const imageUrl = 'https://www.allasrepuestos.com/logos/isotipo.webp';

    // --- Título de la página ---
    this.title.setTitle(pageTitle);

    // --- Meta Descripción ---
    this.meta.updateTag({
      name: 'description',
      content: description,
    });

    // --- Palabras Clave ---
    this.meta.updateTag({
      name: 'keywords',
      content: keywords,
    });

    // --- Open Graph Tags ---
    this.meta.updateTag({ property: 'og:title', content: pageTitle });
    this.meta.updateTag({ property: 'og:description', content: description });
    this.meta.updateTag({ property: 'og:type', content: 'website' });
    this.meta.updateTag({ property: 'og:image', content: imageUrl });
    this.meta.updateTag({
      property: 'og:image:alt',
      content: 'Logo de Allas Repuestos',
    });

    // --- Twitter Tags ---
    this.meta.updateTag({
      name: 'twitter:card',
      content: 'summary_large_image',
    });
    this.meta.updateTag({ name: 'twitter:title', content: pageTitle });
    this.meta.updateTag({ name: 'twitter:description', content: description });
    this.meta.updateTag({ name: 'twitter:image', content: imageUrl });

    // --- Icono del sitio (favicon / logo principal) ---
    this.meta.updateTag({
      name: 'icon',
      content: imageUrl,
    });
  }
}
